<script>

import Anxunheader from "@/views/Anxun/components/Anxunheader.vue";
import kefu from "@/views/kefu.vue";
import headtip from "@/views/headTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import {shareUrl} from "@/utils/vxshare";
import consultTip from "@/components/consultTip.vue";
export default {
  components:{
    bottomTip:bottomTip,
    kefuMobile,
    Anxunheader:Anxunheader,
    kefu:kefu,
    headtip:headtip,
    consultTip
  },
  data(){
    return{
      dialogVisible:false,
      title:'',
      model:false,
      texttotal:{
        headertitle1:"软件定制化设计及开发服务\n\n",
        headertitle2:"量身定制符合客户业务需求的软件应用，确保高效交付与卓越性能\n\n",
        headerimg:require("@/assets/Inspection1.png"),
        introduce:"基于安全法规和行业标准，构建隐患与风险知识库，结合多终端技术，实现风险管控、隐患排查、整改、验收及管理。通过智能分析、预测预警和安全绩效管理，提升安全管理效率和风险控制能力。\n"
      },
      data:[
        {
          title:"业务痛点与挑战",
          img:"/exploit1.png"
        },
        {
          title:"服务流程",
          title2:"需求分析与架构设计",
          img:"/exploit2.png"
        },
        {
          title2:"软件开发和测试",
          img:"/exploit3.png"
        },
        {
          title2:"持续迭代和优化",
          img:"/exploit4.png"
        },
        {
          title2:"系统集成与对接",
          img:"/exploit5.png"
        },
        {
          title:"我们的优势",
          img:"/exploit6.png"
        },
        {
          title:"客户收益",
          img:"/exploit7.png"
        },
      ],
      data2:[
        {
          title:"业务痛点与挑战",
          img:"/exploit11.png"
        },
        {
          title:"服务流程",
          title2:"需求分析与架构设计",
          img:"/exploit12.png"
        },
        {
          title2:"软件开发和测试",
          img:"/exploit13.png"
        },
        {
          title2:"持续迭代和优化",
          img:"/exploit14.png"
        },
        {
          title2:"系统集成与对接",
          img:"/exploit15.png"
        },
        {
          title:"我们的优势",
          img:"/exploit16.png"
        },
        {
          title:"客户收益",
          img:"/exploit17.png"
        },
      ],
      // pc端新增数据
      challenges: [
        {
          icon: require('@/assets/software/exploit/u2.webp'),  // 人才招聘周期长图标
          title: '人才招聘周期长',
          description: '企业招聘技术人才的周期过长，导致项目启动延迟。'
        },
        {
          icon: require('@/assets/software/exploit/u3.webp'),  // 团队能力图标
          title: '团队能力不足',
          description: '现有团队技术能力无法满足特定领域开发需求，需要专家支持。'
        },
        {
          icon: require('@/assets/software/exploit/u4.webp'),  // 长期图标
          title: '长期成本压力',
          description: '维持大规模研发团队的成本高，亟需更灵活的人才策略。'
        }
      ],
      serviceList: [
        {
          title: '弹性合作模式',
          description: '支持驻场开发（派遣工程师至客户现场参与项目）、远程协作（开发团队在线交付任务），以及按项目、按小时或长期雇佣 等多种合作模式，确保企业能够以最优成本获取所需的技术支持。',
          icon: require('@/assets/software/exploit/u28.webp')
        },
        {
          title: '快速匹配技术人才',
          description:'基于企业业务需求和项目技术要求，快速推荐具备相关经验的开发人员，涵盖 前端、后端、移动端、数据库、运维 等多个领域，确保人员技能与项目需求精准匹配。同时，支持短期/长期雇佣，满足企业不同阶段的用人需求。',
          icon: require('@/assets/software/exploit/u35.webp')
        },
        
        {
          title: '完整的项目管理支持',
          description: '成熟的项目管理体系，结合敏捷开发(Agile)或瀑布式开发（Waterfall），确保开发进度可控、任务分工明确，降低沟通成本。提供代码审核、质量保障、定期汇报机制，确保交付物符合客户期望，并按时完成项目目标。',
          icon: require('@/assets/software/exploit/u37.webp')
        }
      ],
      benefitList: [
        {
          icon: require('@/assets/software/exploit/u26.webp'),
          title: '快速组建开发团队,降低招聘成本',
          desc: '依托丰富的人才储备，企业无需投入大量时间招聘，可快速匹配合适的开发人员，填补技术空缺，降低招聘成本。'
        },
        {
          icon: require('@/assets/software/exploit/u27.webp'),
          title: '项目按期交付',
          desc: '提供专业项目管理，结合敏捷开发，确保任务分配合理、进度可控。灵活调配技术人员，快速应对需求变化，避免因人员短缺影响项目进度。'
        },
        {
          icon: require('@/assets/software/exploit/u29.webp'),
          title: '灵活扩展技术团队',
          desc: '企业可根据业务需求灵活调整开发团队，避免固定团队的冗余成本。团队经验丰富，执行标准化流程，确保代码质量、提升开发效率，并提供长期技术支持。'
        }
      ]
    }
  },
  methods:{
    setback(index){
      return index%2;
    },
    ResizeContainer(){
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      console.log("123123232",screenWidth)
      if (screenWidth <= 700) {
        this.model = true
      } else {
        this.model = false
      }
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', this.texttotal['headertitle2']);
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.texttotal['headertitle1']);
      }
    },
    clickConsult(item) {
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      this.dialogVisible = false;
    },
  },
  mounted() {
    document.title = this.texttotal['headertitle1'];
    this.setMetaTags()
    console.log("mountedmoujtned")
    this.ResizeContainer()
  },
  created() {
    localStorage.setItem("home", 0)
    let url = window.location.href
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      // const imageUrl = 'https://i.postimg.cc/N0d3m2C9/GPTLOGO.png'; // Replace with the actual image URL
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        // imageUrl: encodeURIComponent(imageUrl), // Adding the image URL to the shareData object
        pageTitle: this.texttotal['headertitle1'],
        pageDescription: this.texttotal['headertitle2'],
        pageKeywords: '智慧场站，生产工艺管理，智慧安防管理，AR 智能作业，AR 智能巡检，设备全生命周期管理，设备在线监测与预警，场站数字孪生，安迅数智，油气通GPT',
      };
      shareUrl(shareData);
    }, 1000);
  },
}
</script>

<template>
  <div v-if="model==false" ref="total" class="totalmakeHole">
    <div
      :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}"
      style="z-index: 10;padding-left: 3vw;width: 100%" class="topback">
      <headtip :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
    </div>
    <kefu @toptop="topTop"></kefu>
    <!-- <Anxunheader :title1=texttotal.headertitle1 :title2=texttotal.headertitle2
      @clickConsult1="$refs.consultTip.dialogVisible=true"></Anxunheader> -->
      <Anxunheader :title1=texttotal.headertitle1 :title2=texttotal.headertitle2
      @clickConsult1="clickConsult('油气通')"></Anxunheader>

    <div v-for="item,index in data"  :key="item" class="screenmake1" :style="index % 2 == 1?{'background-color':'white'}:{'background-color':'#ebf1fd'}">
      <div v-if="item.title" v-sliden-in="{duration:800}" class="heighLight" v-html="item.title"></div>
      <div v-if="item.title2" v-sliden-in="{duration:800}" class="heighLight1" v-html="item.title2"></div>
      <img :src="require('@/assets'+item.img)">
    </div>
    <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
    <!--业务痛点与挑战模块 -->
    <!-- <div class="screenmake1" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">业务痛点与挑战</div>
      <div class="challenges-list">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div> -->
    <!--服务内容模块-->
    <!-- <div class="screenmake1" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">服务内容</div>
      <div class="service-list">
        <div v-for="(item, index) in serviceList" :key="index" class="service-card" v-sliden-in="{ duration: 800 }">
          <div class="service-title">{{ item.title }}</div>
          <div class="service-desc">{{ item.description }}</div>
          <div class="service-icon">
            <img :src="item.icon">
          </div>
        </div>
      </div>
    </div> -->
    <!-- 客户收益模块 -->
    <!-- <div class="screenmake1" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">客户收益</div>
      <div class="benefit-list">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div> -->
  </div>
  <!-- 以下是移动端的代码 -->
  <div v-else ref="totalModel" class="totalmakeHoleModel">
    <div class="screen1" style="position: relative">
      <kefuMobile @topMobile="topTopmobile"></kefuMobile>
      <headtip @showDialog="showPartner"></headtip>
      <!--      logo  you气通GPT社区 合作伙伴  登录-->

      <!--       油气通GPT 全球油气行业最专业的、开放的大模型人工智能云平台-->
      <div class="layer2">
        <div v-sliden-instep="{duration:800}" class="title1" style="margin: 10px 0px;"><img loading="lazy"
            src="@/assets/AnxunLogo.png"></div>
        <div v-sliden-instep="{duration:1600}" class="title2"
          style="font-weight: bolder;font-size: 25px;margin-top: 15px;line-height: 30px;color:#F44336">
          {{texttotal.headertitle1}}
        </div>
        <div v-sliden-instep="{duration:1600}" class="title2"
          style="font-weight: bolder;margin-top: 15px;font-size: 18px;line-height: 28px;color:#2c3e50;text-align: left">
          {{texttotal.headertitle2}}
        </div>
        <!--              <div v-sliden-instep="{duration:2400}" class="title4" style="font-weight: bolder;font-size: 18px;line-height: 28px;">油气数智，简单易行</div>-->
      </div>
      <div style="position: absolute;bottom: 30px;left: 50%;transform:translateX(-50%);">
        <div v-sliden-instep="{duration:2400}" class="title4"
          style="font-weight: bolder;font-size: 18px;line-height: 28px;padding-bottom: 5px;color: #2f6dfd;">油气数智，简单易行
        </div>
        <div style="font-weight: bolder" class="titlle3"  @click="clickConsult('油气通')">
          产品咨询
        </div>
      </div>
      <!--      平台大图-->
      <div class="layer3"></div>
    </div>
    <div v-for="item,index in data2" :key="item" class="screenmake1"
      :style="index % 2 == 1?{'background-color':'white'}:{'background-color':'#ebf1fd'}">
      <div v-if="item.title" v-sliden-in="{duration:800}" class="heighLight" v-html="item.title"></div>
      <div v-if="item.title2" v-sliden-in="{duration:800}" class="heighLight1" v-html="item.title2"></div>
      <img :src="require('@/assets'+item.img)">
    </div>
        <!--业务痛点与挑战模块 -->
        <!-- <div class="screenmake1" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">业务痛点与挑战</div>
      <div class="challenges-list-mobile">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div> -->
    <!--服务内容模块-->
    <!-- <div class="screenmake1" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">服务内容</div>
      <div class="service-list-mobile">
        <div v-for="(item, index) in serviceList" :key="index" class="service-card-mobile" v-sliden-in="{ duration: 800 }">
          <div class="service-title-mobile">{{ item.title }}</div>
          <div class="service-desc-mobile">{{ item.description }}</div>
          <div class="service-icon-mobile">
            <img :src="item.icon">
          </div>
        </div>
      </div>
    </div> -->
    <!-- 客户收益模块 -->
    <!-- <div class="screenmake1" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">客户收益</div>
      <div class="benefit-list-mobile">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card-mobile">
          <div class="benefit-icon-mobile">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title-mobile">{{ item.title }}</div>
          <div class="benefit-desc-mobile">{{ item.desc }}</div>
        </div>
      </div>
    </div> -->
    <div ref="bottom">
      <bottomTip></bottomTip>
    </div>
    <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
  </div>

</template>

<style scoped lang="scss">
.totalmakeHole{
  .screenmake1 {
    padding: 5.78739184177998vh 8.09763142692085vw;
    width: 100%;
    height: fit-content;
    background: white;
    display: flex;
    flex-direction: column;
    .heighLight {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2.2060658579vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }
    .heighLight1 {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }
    img{
      width: 70vw;
      margin: auto;
    }
        //业务痛点与挑战
        .challenges-list {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      .challenge-card {
        // flex: 1;
        margin: 0 15px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 20px;

          img {
            width: 70px;
            height: 70px;
          }
        }

        .challenge-title {
          font-size: 24px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 15px;
        }

        .challenge-desc {
          font-size: 16px;
          // color: #333;
          color: #000000;
          line-height: 1.6;
          text-align: left;
          max-width: 350px; // 添加最大宽度限制
          margin: 0 auto;
        }
      }
    }
    // 服务内容模块
        .service-list {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          gap: 20px;
          // flex-wrap: wrap;//允许换行
        }
    
        .service-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          padding: 20px;
          width: 460px;
          position: relative;
          min-height: 240px;
          display: flex;
          flex-direction: column;
          border: 1px solid #3a7afe;
        }
    
        .service-title {
          font-size: 25px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #000000;
          letter-spacing: 2px;
          text-align: center;
          position: relative;
          z-index: 2;
        }
    
        .service-desc {
          font-size: 16px;
          color: #000000;
          font-weight: 400;
          line-height: 1.5;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
          // flex-grow: 1;
          position: relative;
          z-index: 2;
        }
    
        .service-icon {
          right: -35px;
          bottom: 0;
          opacity: 0.5;
          z-index: 1;
          position: absolute;
        }
    
        .service-icon img {
          width: 224px;
          height: 144px;
          object-fit: contain;
        }
        // 客户收益模块样式
        
    .benefit-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .benefit-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);

        // padding: 40px 32px 92px 32px;
        padding: 0 0 32px 0;
        min-width: 260px;
        max-width: 360px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .benefit-icon {
          margin-bottom: 24px;

          img {
            // width: 100%;
            // // height: 200px;
            // object-fit: contain;
            width: 376px;
            height: 182px;
          }
        }

        .benefit-title {
          font-size: 24px;
          font-weight: bold;
          // color: #222;
          color: #000000;
          margin-bottom: 18px;
          text-align: center;
          line-height: 1.4;
        }

        .benefit-desc {
          font-size: 16px;
          // color: #333;
          color: #000000;
          // text-align: center;
          line-height: 1.8;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
        }
      }
    }
  }
}
.totalmakeHoleModel{
  .screen1 {
    position: relative;
    width: 100%;
    height: 600px;
    padding: 2.84301606922126vh 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../../assets/bannerModel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;
    /* Add any additional styling as needed */

    .layer2 {
      position: absolute;
      top: 85px;
      left: 9.17157712305026vw;

      .title1 {
        width: 200px;;
        font-size: 3.50606585788562vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2f6eff;
      }

      .title2 {
        margin-top: 5px;
        width: 95%;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #4B5A8B;
        line-height: 24px;
      }

      .title4 {
        margin-top: 15px;

        height: 22px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        font-size: 16px;
        color: #2f6dfd;
        line-height: 0px;
        font-style: normal;
        text-transform: none;
      }


    }

    .titlle3 {
      //position: absolute;
      //bottom: 30px;
      //left: 50%;
      //transform: translateX(-60%);
      font-size: 14px;
      font-family: arial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 9.1px;
      width: fit-content;
      margin: auto;
      padding: 5px 4.6875vw;
      height: 35px;
      color: white;
      background-color: #2f6eff;
      border: 1px solid #2f6eff;
      overflow: hidden;

    }

  }
  .screenmake1 {
    padding: 5.78739184177998vh 2.09763142692085vw;
    width: 100%;
    height: fit-content;
    background: white;
    display: flex;
    flex-direction: column;
    .heighLight {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 6vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }
    .heighLight1 {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 5vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }
    img{
      width: 90vw;
      margin: auto;
    }
    //移动端挑战模块样式
    .challenges-list-mobile {
      margin-top: 20px;

      .challenge-card {
        margin-bottom: 30px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 15px;

          img {
            width: 50px;
            height: 50px;
          }
        }

        .challenge-title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 10px;
        }

        .challenge-desc {
          font-size: 14px;
          color: #333;
          line-height: 1.5;
          text-align: left;
          max-width: 260px; // 移动端可以设置稍小的宽度
          margin: 0 auto;
        }
      }
    }
    // 服务内容移动端样式
    .service-list-mobile{
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 30px;
      .service-card-mobile{
        background: white;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        padding: 20px;
        margin-bottom: 30px;
        width: 100%;
        border: 1px solid #3a7afe;
        display: flex;
        position: relative; /* 添加相对定位 */
        flex-direction: column;
        align-items: center;
      }
      .service-title-mobile{
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        z-index: 2;
      }
      .service-desc-mobile{
       font-size: 14px;
       color: #333;
       line-height: 1.5;
       max-width: 280px; // 移动端可以设置稍小的宽度
       margin: 0 auto;
       position: relative;
       z-index: 2;
       margin: 0 auto 15px; /* 增加底部间距 */
       flex-grow: 1; /* 让描述部分占据剩余空间 */
      }
      .service-icon-mobile{
      //  right: 0;
      // //  bottom: 0;
      right: 15px;
      bottom: 15px;
       opacity: 0.5;
       position: absolute;
       z-index: 1;
      }
      .service-icon-mobile img{
        width: 80px;
        height: 80px;
      }
    }
    // 客户收益移动端样式
     .benefit-list-mobile{
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 30px;

      .benefit-card-mobile{
        background: white;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);
        padding: 0 0 20px 0;
        width: 100%;
        display: flex;
        // flex: 1;
      flex-direction: column;
      align-items: center;
      }
      .benefit-icon-mobile {
        margin-bottom: 16px;

        img {
          width: 100%;
          // height: 48px;
        }
      }
      .benefit-title-mobile {
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.4;
      }
      .benefit-desc-mobile {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        margin: 0 auto;
        max-width: 280px;
      }
     }
  }
}
</style>
